(()=>{
 'use strict';
 const root=(document.body.dataset.root||'/').replace(/\/?$/,'/'), cartUrl=document.body.dataset.cartUrl||'/cart';
 const money=(cents)=>new Intl.NumberFormat(document.body.dataset.locale||'en-US',{style:'currency',currency:document.body.dataset.currency||'USD'}).format(cents/100);
 let cartBusy=false, lastFocus=null;
 const status=(text)=>{const e=document.getElementById('ww-status');if(e)e.textContent=text;};
 const error=(form,message)=>{const e=form?.querySelector('.form-error');if(e)e.textContent=message;else status(message);};
 async function jsonRequest(url,body){
   const response=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
   const data=await response.json();
   if(!response.ok)throw new Error(data.description||data.message||'We couldn’t update your bag. Please try again.');
   return data;
 }
 function openCart(){const d=document.getElementById('CartDrawer');if(!d){location.href=cartUrl;return;}lastFocus=document.activeElement;if(!d.open)d.showModal();d.querySelector('[data-close-cart]')?.focus();}
 function closeCart(){const d=document.getElementById('CartDrawer');d?.close();lastFocus?.focus();}
 async function refreshCart(sections){
   let data=sections;
   if(!data){const response=await fetch(`${root}?sections=ww-cart,ww-main-cart`,{headers:{'Accept':'application/json'}});if(!response.ok)throw new Error('Your bag changed, but the preview could not refresh. Open the bag page to review it.');data=await response.json();}
   for(const [key,selector] of [['ww-cart','[data-cart-drawer-content]'],['ww-main-cart','[data-cart-page-content]']]){
     if(!data[key])continue;
     const parsed=new DOMParser().parseFromString(data[key],'text/html'),source=parsed.querySelector(selector),target=document.querySelector(selector);
     if(source&&target)target.innerHTML=source.innerHTML;
   }
   const response=await fetch(`${root}cart.js`,{headers:{'Accept':'application/json'}});
   if(response.ok){const c=await response.json();document.querySelectorAll('[data-cart-count]').forEach(e=>e.textContent=c.item_count);return c;}
 }
 function showMedia(section,id){
   const gallery=section?.querySelector('[data-product-gallery]');
   if(!gallery?.querySelector(`[data-gallery-item="${id}"]`))return;
   gallery.querySelectorAll('[data-gallery-item]').forEach(el=>{
     el.hidden=el.dataset.galleryItem!==id;
     if(el.hidden)el.querySelectorAll('video').forEach(video=>video.pause());
   });
   section.querySelectorAll('[data-show-media]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.showMedia===id)));
 }
 function initGallery(scope=document){
   scope.querySelectorAll('[data-product-section]').forEach(section=>{
     const gallery=section.querySelector('[data-product-gallery]'), first=gallery?.querySelector('[data-gallery-item]');
     if(!first||gallery.dataset.ready)return;
     gallery.dataset.ready='1';gallery.classList.add('is-enhanced');
     const thumbs=section.querySelector('[data-gallery-thumbnails]');if(thumbs)thumbs.hidden=false;
     showMedia(section,first.dataset.galleryItem);
     section.addEventListener('click',event=>{const button=event.target.closest('[data-show-media]');if(button)showMedia(section,button.dataset.showMedia);});
   });
 }
 function initTiers(scope=document){
   scope.querySelectorAll('.tier-form').forEach(form=>{
     const labels=form.querySelector('[data-tier-labels]')?.dataset||{}, cards=[...form.querySelectorAll('[data-offer-card]')];
     const normalName=name=>/color/i.test(name)?'color':name.toLowerCase();
     const updateCard=card=>{
       const select=card.querySelector('[data-offer-variant]'), controls=[...card.querySelectorAll('[data-option-index]')];
       if(controls.length){
         const match=[...select.options].find(opt=>controls.every(c=>opt.dataset[`option${Number(c.dataset.optionIndex)+1}`]===c.value));
         select.value=match?.value||'';
       }
       const opt=select.selectedOptions[0], available=opt?.dataset.available==='true', notice=card.querySelector('[data-offer-status]');
       if(notice){notice.hidden=available;notice.textContent=opt?labels.unavailable:labels.noMatch;}
       if(opt){
         const price=Number(opt.dataset.price),compare=Number(opt.dataset.compare||0),saving=Math.max(0,compare-price);
         card.querySelector('[data-offer-price]').textContent=money(price);
         card.querySelector('[data-offer-compare]').textContent=money(compare);
         card.querySelector('[data-offer-anchor]').hidden=saving<=0;
         const badge=card.querySelector('[data-offer-savings]');badge.hidden=saving<=0;badge.textContent=(labels.save||'__AMOUNT__').replace('__AMOUNT__',money(saving));
       }
       return opt;
     };
     const syncOptions=source=>{
       for(const control of source.querySelectorAll('[data-option-index]')){
         const name=normalName(control.dataset.optionName);
         for(const card of cards){if(card===source)continue;
           for(const target of card.querySelectorAll('[data-option-index]'))if(normalName(target.dataset.optionName)===name&&[...target.options].some(o=>o.value===control.value))target.value=control.value;
         }
       }
       cards.forEach(updateCard);
     };
     const choose=()=>{
       const radio=form.querySelector('[data-offer-radio]:checked'),card=radio?.closest('[data-offer-card]');if(!card)return;
       const select=card.querySelector('[data-offer-variant]'),opt=updateCard(card);
       form.querySelector('[data-selected-variant]').value=opt?.value||'';
       cards.forEach(c=>c.classList.toggle('is-selected',c===card));
       form.querySelectorAll('[data-selection-title]').forEach(e=>e.textContent=select.dataset.title);
       form.querySelectorAll('[data-selection-variant]').forEach(e=>e.textContent=opt?.textContent==='Default Title'?'':(opt?.textContent||labels.noMatch));
       form.querySelectorAll('[data-selection-price]').forEach(e=>e.textContent=opt?money(Number(opt.dataset.price)):'');
       form.querySelectorAll('[data-tier-submit]').forEach(button=>{button.disabled=opt?.dataset.available!=='true';button.textContent=button.disabled?labels.unavailable:(button.closest('.sticky-buy')?labels.stickyAdd:labels.add);});
       const section=form.closest('[data-product-section]'),color=[...card.querySelectorAll('[data-option-index]')].find(c=>normalName(c.dataset.optionName)==='color')?.value;
       if(color){
         section?.querySelectorAll('[data-stand-color]').forEach(el=>el.hidden=el.dataset.standColor!==color);
         const imageOpt=[...form.querySelectorAll('[data-offer-variant] option')].find(o=>o.dataset.option1===color&&o.dataset.mediaId);
         if(imageOpt)showMedia(section,imageOpt.dataset.mediaId);
       }else if(opt?.dataset.mediaId&&radio.value===section?.dataset.currentProduct)showMedia(section,opt.dataset.mediaId);
       error(form,'');
     };
     if(!form.dataset.wwReady){
       for(const card of cards){
         const select=card.querySelector('[data-offer-variant]'),current=select.selectedOptions[0];
         card.querySelectorAll('[data-option-index]').forEach(c=>c.value=current?.dataset[`option${Number(c.dataset.optionIndex)+1}`]||c.value);
         const controls=card.querySelector('[data-option-controls]');
         if(controls){controls.hidden=false;card.querySelector('[data-variant-fallback]').hidden=true;}
       }
       form.addEventListener('change',event=>{
         const card=event.target.closest('[data-offer-card]');if(!card)return;
         if(event.target.matches('[data-option-index]')){card.querySelector('[data-offer-radio]').checked=true;syncOptions(card);}
         if(event.target.matches('[data-offer-variant]')){
           const opt=event.target.selectedOptions[0];card.querySelectorAll('[data-option-index]').forEach(c=>c.value=opt.dataset[`option${Number(c.dataset.optionIndex)+1}`]);
           card.querySelector('[data-offer-radio]').checked=true;syncOptions(card);
         }
         choose();
       });
       form.dataset.wwReady='1';
       const selected=form.querySelector('[data-offer-radio]:checked')?.closest('[data-offer-card]');if(selected)syncOptions(selected);
     }
     choose();
   });
 }
 document.addEventListener('submit',async event=>{
   const form=event.target;
   if(!form.matches('.ww-product-form'))return;
   event.preventDefault();if(cartBusy)return;cartBusy=true;error(form,'');
   const buttons=[...form.querySelectorAll('button[type=submit]')];buttons.forEach(b=>{b.dataset.wasDisabled=String(b.disabled);b.disabled=true;b.setAttribute('aria-busy','true');});
   let added=false;
   try{
     const fd=new FormData(form),id=fd.get('id');if(!id)throw new Error('Choose an available product option first.');
     const result=await jsonRequest(`${root}cart/add.js`,{items:[{id:Number(id),quantity:Number(fd.get('quantity')||1)}],sections:['ww-cart','ww-main-cart'],sections_url:location.pathname});added=true;
     await refreshCart(result.sections);openCart();status('Added to your bag.');
   }catch(e){error(form,added?'Added to your bag. Open the bag page to review your items.':e.message);}
   finally{cartBusy=false;buttons.forEach(b=>{b.disabled=b.dataset.wasDisabled==='true';b.removeAttribute('aria-busy');});}
 });
 document.addEventListener('click',async event=>{
   const open=event.target.closest('[data-open-cart]');if(open){event.preventDefault();openCart();return;}
   if(event.target.closest('[data-close-cart]')){closeCart();return;}
   const remove=event.target.closest('[data-remove-key]');if(remove){event.preventDefault();await changeQuantity(remove.dataset.removeKey,0,remove.closest('.cart-form'));}
 });
 document.addEventListener('click',e=>{const d=document.getElementById('CartDrawer');if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeCart();}});
 async function changeQuantity(key,quantity,form){
   if(cartBusy)return;cartBusy=true;error(form,'');
   const qtyInputs=[...document.querySelectorAll('[data-cart-quantity],.checkout-button')];qtyInputs.forEach(x=>x.disabled=true);
   try{const result=await jsonRequest(`${root}cart/change.js`,{id:key,quantity,sections:['ww-cart','ww-main-cart'],sections_url:location.pathname});await refreshCart(result.sections);status('Bag updated.');}
   catch(e){const message=e.message;try{await refreshCart();}catch(_){}document.querySelectorAll('.cart-form').forEach(f=>error(f,message));status(message);}
   finally{cartBusy=false;qtyInputs.forEach(x=>x.disabled=false);}
 }
 document.addEventListener('change',e=>{if(e.target.matches('[data-cart-quantity]')){const n=Number(e.target.value);if(Number.isInteger(n)&&n>=0)changeQuantity(e.target.dataset.key,n,e.target.closest('.cart-form'));}});
 document.addEventListener('change',async e=>{if(e.target.matches('[data-cart-note]')){const note=e.target.value;try{await jsonRequest(`${root}cart/update.js`,{note});document.querySelectorAll('[data-cart-note]').forEach(x=>x.value=note);}catch(err){error(e.target.closest('.cart-form'),'Your note was not saved yet. Checkout will submit this note again.');}}});
 document.addEventListener('input',e=>{if(e.target.matches('[data-before-after]'))e.target.closest('.before-after').style.setProperty('--split',`${e.target.value}%`);});
 function initRecommendations(scope=document){scope.querySelectorAll('product-recommendations[data-url]').forEach(el=>{
   if(el.dataset.loaded)return;el.dataset.loaded='1';
   const io=new IntersectionObserver(async entries=>{if(!entries.some(x=>x.isIntersecting))return;io.disconnect();try{const r=await fetch(el.dataset.url);if(!r.ok)return;const parsed=new DOMParser().parseFromString(await r.text(),'text/html'),block=parsed.querySelector('product-recommendations');if(block&&block.innerHTML.trim())el.innerHTML=block.innerHTML;}catch(_){}});io.observe(el);
 });}
 document.addEventListener('shopify:section:load',e=>{initGallery(e.target);initTiers(e.target);initRecommendations(e.target);});
 initGallery();initTiers();initRecommendations();
})();
